"use client";
// Déclencheur global de la modale connexion/inscription (« lazy signup »).
// N'importe quel composant appelle openAuthPrompt("favorite" | "setup") quand un
// visiteur NON connecté tente une action réservée ; la modale — montée une seule
// fois au layout racine — écoute et s'ouvre. Même patron pub/sub que favorites.ts.

export type AuthPromptReason = "favorite" | "setup" | null;

type Listener = (reason: AuthPromptReason) => void;
const listeners = new Set<Listener>();

export function openAuthPrompt(reason: AuthPromptReason = null) {
  for (const l of listeners) l(reason);
}

export function onAuthPrompt(listener: Listener) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
